<template>
  <v-hover v-slot="{ hover }">
    <v-card elevation="0" :class="{ 'on-hover': hover }" :disabled="disabled">
      <v-row :class="{ 'group-card-selected': isSelected }">
        <v-col cols="auto" class="pr-0">
          <v-img
            class="rounded-xl"
            width="80"
            height="80"
            :src="
              item.image
                ? conf.apiUrlBase +
                  '/gallery/' +
                  item.image.restaurant_id +
                  '/medium/' +
                  item.image.name
                : './media/img/no-image.webp'
            "
          />
        </v-col>
        <v-col align="start" class="font-weight-bold">
          <v-row no-gutters align="center" class="fill-height">
            <v-col>
              <h3 class="body-2 font-weight-medium">
                {{ translate(item.name) }}
              </h3>
            </v-col>
            <v-col v-if="rolaCompany" cols="auto">
              <v-row no-gutters align="center" justify="end">
                <circle-button
                  @click="$emit('subFood')"
                  icon="mdi-minus-circle-outline"
                ></circle-button>
                <span class="px-1 body-1 font-weight-medium">{{ item.quantity }}</span>
                <circle-button
                  @click="$emit('addFood')"
                  icon="mdi-plus-circle-outline"
                ></circle-button>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>
</template>

<script>
import conf from "@/config";

export default {
  name: "CategoryMenuGroupCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      conf,
    };
  },
  computed: {
    rolaCompany() {
      return this.$store.state.user.user?.type === "company";
    },
  },
  methods: {
    convert(name) {
      return this.$store.state.isLatin ? name : this.$store.state.convert(name);
    },
    addFood(item) {
      this.$emit("add-food", item);
    },
    subFood(item) {
      this.$emit("sub-food", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

// Selected group card
.group-card-selected {
  background: $primary-light;
  border: 1px solid $primary-light;
}
</style>
